import { FC, useEffect, useState } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceRoModel";
import { RouterParamType } from "@/model/navModel";
import { ThreeGuaranteesList } from "../vrmBillMaintenanceRoType";
import { useGlobalModel } from "@/model/globalModel";


export const ThreeGuarantees: FC<RouterParamType> = ({ id, mode }) => {

    const { threeGuaranteesItemDetail } = useVrmMaintenanceDetailsModel();
    const { getCiDictByDictCode } = useGlobalModel(() => []);

    const [totalPrice, setTotalPrice] = useState<string>("0");

    const title = <>
        <span>三包信息</span>
        <span style={{ marginLeft: '50px', fontSize: '14px' }}>
            总金额&nbsp;¥&nbsp;<span style={{ color: 'red', fontSize: '18px' }}>{totalPrice}</span>
            &nbsp;元&nbsp;({threeGuaranteesItemDetail.length}项){" "}
        </span>
    </>

    //计算总价
    useEffect(() => {
        let num: number = 0
        threeGuaranteesItemDetail.forEach((item) => {
            num += Number(item.totalClaim)
        })
        setTotalPrice(num.toFixed(2));
    }, [threeGuaranteesItemDetail])

    const itemColumn: ColumnsType<ThreeGuaranteesList> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: "三包品牌",
            dataIndex: "threeGuaranteesBrand",
            align: "center",
            width: 100,
            render: (text) => <span>{getCiDictByDictCode(text)?.title}</span>,
        },
        {
            title: "维修人员",
            dataIndex: "maintenanceStaff",
            align: "center",
            width: 80,
        },
        {
            title: "维修时间",
            dataIndex: "repairTime",
            align: "center",
            width: 160,
        },
        {
            title: "索赔单号",
            dataIndex: "claimNumber",
            align: "center",
            width: 100,
        },
        {
            title: "故障处理",
            dataIndex: "faultHandle",
            align: "center",
            width: 200,
        },
        {
            title: "材料费",
            dataIndex: "materialAmount",
            align: "center",
            width: 80,
        },
        {
            title: "出库金额",
            dataIndex: "outboundAmount",
            align: "center",
            width: 80,
        },
        {
            title: "工时费",
            dataIndex: "hourlyWage",
            align: "center",
            width: 80,
        },
        {
            title: "外出费",
            dataIndex: "travelExpenses",
            align: "center",
            width: 80,
        },
        {
            title: "餐补费",
            dataIndex: "mealSupplement",
            align: "center",
            width: 80,
        },
        {
            title: "其他费用",
            dataIndex: "otherAmount",
            align: "center",
            width: 80,
        },
        {
            title: "索赔总额",
            dataIndex: "totalClaim",
            align: "center",
            width: 80,
        },
        {
            title: "结算单号",
            dataIndex: "statementNumber",
            align: "center",
            width: 100,
        },
        {
            title: "三包工时费汇总",
            dataIndex: "totalHourlyWage",
            align: "center",
            width: 120,
        },
    ];
    return (
        <YhBox title={title} style={{ marginBottom: "5px" }}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={itemColumn}
                dataSource={threeGuaranteesItemDetail}
                pagination={false}
                scroll={{ x: 'max-content', y: 250 }}
            />
        </YhBox>
    )
}